{
  "09fb67d57bc78f93": "Añadir una clave de acceso",
  "0c89d866efe705b5": "¿No sabes tu contraseña actual o aún no tienes una?",
  "11097d9deb0ad0ae": "Clave de acceso eliminada",
  "11a6767d5674c7e4": "Hecho",
  "130011756125313c": "Encendido",
  "1509f561f2416598": "Guardar",
  "18ac6380138bdd5b": "Resumen Diario de Tiempo",
  "19766ed6ccb2f4a3": "Cancelar",
  "1b21c5e9cfc510fb": "¿Está seguro de que desea desactivar?",
  "1c30dea370683e3c": "No has añadido ninguna clave de acceso aún.",
  "1e3564bdba890599": "Preferencias de Notificación",
  "1f7227ba0c569543": "Desactivar Cuenta",
  "203c79fe20bbf056": "&#x2022;",
  "259a1c90bc00df46": "Por favor, ingrese un número de celular válido de EE. UU.",
  "25de2f171b5bb91f": "Correo electrónico para restablecer la contraseña enviado a {{userEmail}}.",
  "285e229fe9526851": "Su cuenta no tiene una dirección de correo electrónico. Por favor, contacte al soporte.",
  "286a3af7348e8312": "Enviando...",
  "28ad230b46ce7f37": "Teléfono fijo",
  "312873712eff4228": "Error al desactivar el usuario",
  "3dd9df4441fb348f": "Nueva contraseña",
  "3e2a22f4bbb80ade": "Desvincular Cuenta",
  "3f9c991f63a9a376": "Cambiar contraseña",
  "464c4ffd019e1e96": "Editar",
  "4ba2056e9ba62960": "Notificaciones Web",
  "56ad18c6bbb2efc6": "¿Está seguro de que desea desvincularse de {{workplaceName}}?",
  "5c81e533cbb65983": "Las notificaciones por SMS están deshabilitadas porque no se ha configurado ningún número de móvil. Agregue un número de móvil en Información Personal para habilitar las notificaciones por SMS.",
  "5d30556f50ec96d6": "Error al actualizar la información personal",
  "5e31b73d3d36bee7": "Desactivar cuenta",
  "5e7f0d7d6c6a94e7": "No pudimos cargar tus claves de acceso. Por favor, inténtalo de nuevo.",
  "60d18e42fd5a5b25": "Eliminando...",
  "72ed2bd767cef627": "Contraseña actual",
  "731ce7ed808913b2": "Empujar",
  "8db6b6ec511e793b": "Una clave de acceso te permite iniciar sesión con la huella digital, el rostro o el bloqueo de pantalla de tu dispositivo, sin necesidad de contraseña o enlace de correo electrónico. Es más rápido y seguro. Después de añadir una, elige \"Iniciar sesión con una clave de acceso\" en la pantalla de inicio de sesión y confirma con tu dispositivo.",
  "8fb9beb223ae544b": "Error al cargar los detalles de la cuenta. Por favor, inténtelo de nuevo.",
  "904c9aa9baaef704": "Clave de acceso",
  "929b1b5635346bbd": "Enviar un correo electrónico de restablecimiento",
  "942087cc2d41e013": "Reintentar",
  "958e4ccf2953d747": "Por favor, ingrese una dirección de correo electrónico válida.",
  "969ccbd3cf6300ec": "Correo Electrónico",
  "96ce6e6193a04726": "Nombre",
  "999bd6c24bbb567c": "¿No sabe su contraseña actual?",
  "9e12da5e3227bf5d": "Error al desvincular el usuario",
  "a6ac8a2a2f638962": "Editar información personal",
  "a949f46230748d3f": "Cambiar contraseña",
  "ad0187add790ff17": "Mi Cuenta",
  "b286c7f6e0ef9fb1": "Teléfono móvil",
  "b328c0544845a4f8": "Por favor, ingrese un número de teléfono fijo válido de EE. UU.",
  "b36c2611dcdfa190": "Diario",
  "b6eb82cd3300c838": "Las contraseñas no coinciden",
  "bab342a878b1b458": "Tus claves de acceso",
  "baefbeca157e01b4": "Solo añade una clave de acceso en un dispositivo que sea tuyo. No la añadas en una computadora compartida o pública: cualquier persona que pueda desbloquear ese dispositivo podría iniciar sesión como tú.",
  "bb1d910d2ce54d39": "perderá el acceso a {{workplaceName}}, pero mantendrá el acceso a otros lugares de trabajo:",
  "bf000421aeb39493": "Confirmar nueva contraseña",
  "c3812fc4acb861d5": "Eliminar",
  "c4b37e84b553d29b": "Información Personal",
  "c87ccdb428e6e24c": "Claves de acceso",
  "ca009c3212e4e3d0": "Tu nueva contraseña no puede comenzar ni terminar con un espacio.",
  "ca7981b46ecf2c17": "Apagado",
  "d493798b58334f24": "Contraseña cambiada exitosamente",
  "d4c687a498dfad56": "Desvincularse del lugar de trabajo",
  "dcd1d5223f73b3a9": "Nombre",
  "dcd91a1072001642": "Clave de acceso añadida",
  "de2c883522422d43": "Título del trabajo",
  "e3b8d09d1ac4b9f1": "La contraseña debe tener al menos 8 caracteres",
  "e7d7f144db509e75": "Envía un correo electrónico para configurar tu nueva contraseña",
  "eea61c4a94b11c2e": "Añadido {{date}}",
  "f1cac3406440c4e1": "Gestionar claves de acceso",
  "f2b1e1fd996e14eb": "perderá el acceso a todos los lugares de trabajo asociados y ya no podrá iniciar sesión.",
  "f55563b386a39dc3": "Apellido"
}
